var _defs, _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "creditCard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.207,
    height: 15.268,
    viewBox: "0 0 24.207 15.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.358,
    y1: -0.082,
    x2: 0.711,
    y2: 1.362,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.355,
    x2: 0.5,
    y2: 1.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.418,
    y1: -0.334,
    x2: 0.578,
    y2: 1.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.372,
    y1: 0.269,
    x2: 0.621,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.372,
    y1: 0.269,
    x2: 0.621,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M22.376,212.243H1.831A1.831,1.831,0,0,1,0,210.412V198.807a1.831,1.831,0,0,1,1.831-1.831H22.376a1.831,1.831,0,0,1,1.831,1.831v11.606A1.831,1.831,0,0,1,22.376,212.243Z",
    transform: "translate(0 -196.976)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_154",
    "data-name": "Trac\\xE9 154",
    d: "M0,399.161v1.691a1.831,1.831,0,0,0,1.831,1.831H22.376a1.831,1.831,0,0,0,1.831-1.831v-1.691Z",
    transform: "translate(0 -387.415)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_155",
    "data-name": "Trac\\xE9 155",
    d: "M0,240.817H24.207v4.288H0Z",
    transform: "translate(0 -238.27)",
    fill: "url(#linear-gradient-3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_157",
    "data-name": "Groupe 157",
    transform: "translate(1.797 9.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155",
    "data-name": "Groupe 155"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.786,
    cy: 1.786,
    r: 1.786,
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.786,
    cy: 1.786,
    r: 1.786,
    transform: "translate(2.681)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156",
    "data-name": "Groupe 156",
    transform: "translate(12.283 0.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_156",
    "data-name": "Trac\\xE9 156",
    d: "M250.356,371.363H242.7a.335.335,0,0,1-.335-.335v-.58a.335.335,0,0,1,.335-.335h7.66a.335.335,0,0,1,.335.335v.58A.335.335,0,0,1,250.356,371.363Z",
    transform: "translate(-242.361 -370.114)",
    fill: "#0469bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M246.767,407.95H242.7a.335.335,0,0,1-.335-.335v-.58a.335.335,0,0,1,.335-.335h4.071a.335.335,0,0,1,.335.335v.58A.335.335,0,0,1,246.767,407.95Z",
    transform: "translate(-242.361 -404.576)",
    fill: "#0469bb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.3da28e2e.svg";
export { ForwardRef as ReactComponent };